export enum WsConnectionStatus {
  waiting = 'waiting',
  connecting = 'connecting',
  connected = 'connected',
  opened = 'opened',
  closed = 'closed',
  error = 'error',
  heartbeat = 'heartbeat',
  disconnected = 'disconnected',
}
